// extracted by mini-css-extract-plugin
export default {"customFileInput":"aa3RZ6OM","text":"CBCIMLMH"};